import { useAccount, useDisconnect, useEnsAvatar, useEnsName } from 'wagmi'


export function Connection() {
  const {isConnected } = useAccount()
  const { address } = useAccount()
  const { disconnect } = useDisconnect()
  const { data: ensName } = useEnsName({ address })
  const { data: ensAvatar } = useEnsAvatar({ name: ensName! })

  return (
    <div className="flex flex-row w-full justify-between items-center gap-4">
      <div className="flex flex-col items-start gap-2">
        <p className="!text-sm text-gray-500 mb-0">
          {isConnected ? 'Connected as:' : 'Connect your wallet'}
        </p>
        <div className="flex flex-row items-center gap-2">
          {ensAvatar && <img alt="ENS Avatar" src={ensAvatar} />}
          {address && <div>{ensName ? `${ensName} (${address})` : address}</div>}
        </div>
      </div>
      <button className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
      onClick={() => disconnect()}>Disconnect</button>
    </div>
  )
}